import React, { Fragment } from 'react';
import { Container } from '@material-ui/core';
import Button from '@mui/material/Button';
import {makeStyles} from "@material-ui/core/styles";
import logo from '../../img/Stedman-Logo-sm.jpg';
import { Facebook, Email } from '@mui/icons-material/';
import PayPalLogo from '../../img/paypal-seeklogo.com.svg';
import { NavLink, Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    header: {
        backgroundColor: '#abc',
        clear:'both',
        width: '100%',
        height: '10vh',
        borderBottom: '2px solid #0A2466',
        zIndex: '1000',
        '& > div': {
            position: 'relative',
            height: '100%',
        }
    },
    btmHeader: {
        position: 'absolute',
        bottom: '0px',
        width: '100%',
        height: '60px',
    },
    navLinks: {
        display: 'flex',
        justifyContent: 'space-evenly',
        '& a': {
            lineHeight: '56px',
        },
    },
    container: {
        position: 'relative',
        justifyContent: 'space-between',
        height: '60px',
        display: 'flex',
        padding: '10px 0',
    },
    logoContainer: {
        width: '200px',
        padding: '5px 30px',
        marginTop: 'auto',
        backgroundColor: '#fff',
        border: '2px solid #0A2466',
        '& img': {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    donateContainer: {
        display: 'flex',
        height: '80px',
        '& > a': {
            marginLeft: 'auto',
        },
    },
    btnContainer: {
        display: 'flex',
        width: '200px',
        '& a': {
            marginRight: '40px',
            fontSize: '46px',
            display: 'flex',
            '&:hover svg': {
                color: '#0966d2',
            }
        },
        '& path': {
          // filter: 'drop-shadow(1px 1px 1px rgba(0,0,0,.5))',
        },
    },
    payPalbtn: {
        '& a': {
          height: '70px',
          width: '240px',
          fontSize: '2.1em',
          fontWeight: '600',
          marginTop: '3px'
        },
        '& img': {
            marginRight: '10px',
            width: '40px',
            height: 'auto',
        }
    },
    fbBtn: {
        fontSize: '48px',
    },
}));

const Header = () => {
    const classes = useStyles();

    return (
        <Fragment>
            <div className={classes.header}>
                <div>
                    <Container>
                        <div className={classes.container}>
                            <div className={classes.logoContainer}>
                                <img src={logo} alt='Stedman For Senate'/>
                            </div>
                            <div className={classes.donateContainer}>
                                {/* <a className={classes.fbBtn} href='mailto:bert@stedmanforsenate.com?subject=Campaign Contact' target='_blank' rel="noopener noreferrer">
                                    <Email color='primary' fontSize='inherit' />
                                </a>
                                <a className={classes.fbBtn} href="https://www.facebook.com/stedmanforsenate/" target='_blank' rel="noopener noreferrer">
                                    <Facebook color='primary' fontSize='inherit'/>
                                </a> */}
                                <div className={classes.payPalbtn}>
                                    <Button variant='contained' href='https://www.paypal.com/ncp/payment/3GWWYDMCP6NXE' target='_blank'>
                                        <img src={PayPalLogo} alt="Stedman for Senate PayPal Donate button"/>
                                        Donate
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Container>
                    {/*<div className={classes.btmHeader}>*/}
                    {/*    <Container>*/}
                    {/*        <div className={classes.navLinks}>*/}
                    {/*            <Link to='/'>Home</Link>*/}
                    {/*            <Link to='/articles'>Articles</Link>*/}
                    {/*            <Link to='/leadership'>Leadership</Link>*/}
                    {/*            <Link to='/contact'>Contact</Link>*/}
                    {/*        </div>*/}
                    {/*    </Container>*/}
                    {/*</div>*/}
                </div>
            </div>
        </Fragment>
    )
}

export default Header;
